import { ApiService, TApiServiceError, TApiServiceOptions } from "../apiService";
import type {
  TDataAccessRequestResponse,
  TDataAnonymizationResponse,
  TDataDeletionRequest,
  TDataDeletionResponse,
  TDataPortabilityResponse,
  TDataRectificationRequest,
  TDataRectificationResponse,
} from "./gdpr.types";

import { handleAsync } from "@/utils";
import { TApiResponse } from "../../types/api";
import { withAuthHooks } from "../auth/auth.ky.hooks";

const apiService = new ApiService({
  hooks: {
    ...withAuthHooks,
  },
});

class GDPRService {
  private rootEndpoint = "gdpr" as const;

  requestDataAccess(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TApiResponse<TDataAccessRequestResponse>>(() =>
      apiService.post(`${this.rootEndpoint}/data-access-request`, undefined, options)
    );
  }

  requestDataRectification(payload: TDataRectificationRequest, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TApiResponse<TDataRectificationResponse>>(() =>
      apiService.post(`${this.rootEndpoint}/data-rectification`, payload, options)
    );
  }

  requestDeletion(payload: TDataDeletionRequest, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TApiResponse<TDataDeletionResponse>>(() =>
      apiService.post(`${this.rootEndpoint}/right-to-be-forgotten`, payload, options)
    );
  }

  requestDataPortability(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TApiResponse<TDataPortabilityResponse>>(() =>
      apiService.post(`${this.rootEndpoint}/data-portability`, undefined, options)
    );
  }

  requestAnonymization(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TApiResponse<TDataAnonymizationResponse>>(() =>
      apiService.post(`${this.rootEndpoint}/data-anonymization`, undefined, options)
    );
  }
}

export const gdprService = new GDPRService();
export type {
  TDataAccessRequestResponse,
  TDataAnonymizationResponse,
  TDataDeletionRequest,
  TDataDeletionResponse,
  TDataPortabilityResponse,
  TDataRectificationRequest,
  TDataRectificationResponse,
};
